import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { UploadedFiles } from '../../../../../../../types/Shared';
import { capitalize, formatDate3 } from '../../../../../../../utils';
import { PriorProjectInterface } from '../../../../../../Applications/CCLFForm/type';
import {
  clientApplicationConstructionType,
  clientApplicationProjectType,
} from '../../../../../../Applications/ClientApplication/constants';
import { CurrencyFormatDisplay } from '../../../../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';
import { ApplicationAttachments } from '../../../../ApplicationAttachments';
interface PriorProjectsProps {
  project: PriorProjectInterface;
  files: UploadedFiles[];
  index: number;
}
export const PriorProjects = ({
  project,
  files: priorProjectFiles,
  index,
}: PriorProjectsProps) => {
  const { id = 0 } = useParams();
  const queryClient = useQueryClient();

  return (
    <div className='grid md:grid-cols-2 xl:grid-cols-4 gap-4 w-full border rounded-md px-4 py-2 capitalize'>
      <div>
        <dt className='text-sm font-medium text-gray-500'>Project Address</dt>
        <dd>{project.address}</dd>
        <dd>{project.city}</dd>
        <dd>
          {project.state},{project.zipCode}
        </dd>
      </div>
      <div className='space-y-2'>
        <div>
          <dt className='text-sm font-medium text-gray-500'>Project Type</dt>
          <dd>{clientApplicationProjectType[project.projectType]}</dd>
        </div>
        <div>
          <dt className='text-sm font-medium text-gray-500'>
            Construction Type
          </dt>
          <dd>{clientApplicationConstructionType[project.constructionType]}</dd>
        </div>
      </div>
      <div className='space-y-2'>
        <div>
          <dt className='text-sm font-medium text-gray-500'>Completion Date</dt>
          <dd>{formatDate3(project.completionDate)}</dd>
        </div>
        <div>
          <dt className='text-sm font-medium text-gray-500'>Project Status</dt>
          <dd>{capitalize(project.status)}</dd>
        </div>
      </div>
      <div>
        <dt className='text-sm font-medium text-gray-500'>
          Total Project Cost
        </dt>
        <dd>
          <CurrencyFormatDisplay value={project.projectCost} prefix='$' />
        </dd>
      </div>
      <div className='md:col-span-2 xl:col-span-4'>
        <ApplicationAttachments
          title='Pictures'
          files={priorProjectFiles}
          accept='image/x-png,image/gif,image/jpeg'
          applicationId={id as number}
          onUploadOrDeleteActionSuccess={() => {
            queryClient.invalidateQueries(['get-client-application']);
          }}
          field={`orgExperience.priorProjects.${index}.pictures:${project.arrayId}`}
        />
      </div>
    </div>
  );
};
